import { Outlet } from "react-router-dom";
import ClientSidebar from "./client_sidebar";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index"

const ClientDashboard = () => {
  return (
    <>
    <ClientHeader />
    {/* <div className="d-flex">
      <ClientSidebar />
      <div className="flex-grow-1 p-4">
        <Outlet />
      </div>
    </div> */}
    <main className="overflow-hidden">
      <section className="homepad">
        <div className="container">
          <div className="row">
            <ClientSidebar />
            <Outlet />
          </div>
        </div>
      </section>
      <ClientFooter />
    </main>
    </>
  );
};

export default ClientDashboard;